import { useQuery } from 'react-query';
import { queryAllDIRProspects } from './useDIRProspects.query';
import { UseDIRProspectsQueryParams, UseDIRProspectsResponse } from './useDIRProspects.types';

export const ALL_DIR_PROSPECTS_QUERY_KEY = 'ALL_DIR_PROSPECTS';

export const useDIRProspects = (params: UseDIRProspectsQueryParams) => {
  return useQuery<UseDIRProspectsResponse, Error>(
    [ALL_DIR_PROSPECTS_QUERY_KEY, params],
    () => queryAllDIRProspects(params),
    {
      retry: false,
      cacheTime: 0,
    }
  );
};
